import { Link } from 'react-router-dom';

export default function Header(){
  return (
    <nav className="bg-white/95 backdrop-blur-md shadow sticky top-0 z-50 border-b">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="text-2xl font-extrabold bg-gradient-to-r from-slate-800 via-amber-600 to-stone-700 bg-clip-text text-transparent">📄 Letterly</Link>
        <div className="hidden md:flex gap-6 text-slate-600 font-medium">
          <Link to="/dashboard"  className="hover:text-amber-600">Dashboard</Link>
          <Link to="/templates"  className="hover:text-amber-600">Templates</Link>
          <Link to="/jobs"       className="hover:text-amber-600">PDF Jobs</Link>
          <Link to="/upload"     className="hover:text-amber-600">Upload</Link>
        </div>
      </div>
    </nav>
  );
}
